import c0 from './address_geocode_prefill_controller';
import c1 from './ama_publish_controller';
import c2 from './amount_toggle_controller';
import c3 from './auto_save_controller';
import c4 from './autolink_controller';
import c5 from './beacon_link_controller';
import c6 from './bridge/beacon_link_controller';
import c7 from './bridge/intercom_controller';
import c8 from './bridge/menu_controller';
import c9 from './bridge/navigation_controller';
import c10 from './click_tracker_controller';
import c11 from './confirmation_controller';
import c12 from './copy_to_clipboard_controller';
import c13 from './custom_domain_validation_controller';
import c14 from './email_validation_controller';
import c15 from './expandable_content_controller';
import c16 from './extra_support_controller';
import c17 from './feed_item_switcher_controller';
import c18 from './form_controller';
import c19 from './highcharts_controller';
import c20 from './image_preview_controller';
import c21 from './live_activity_feed_controller';
import c22 from './live_poll_dashboard_controller';
import c23 from './live_poll_options_controller';
import c24 from './login_code_controller';
import c25 from './login_controller';
import c26 from './new_tab_link_controller';
import c27 from './notification_preferences_controller';
import c28 from './password_validator_controller';
import c29 from './plan_toggle_controller';
import c30 from './plan_unwrap_controller';
import c31 from './play_controls_controller';
import c32 from './post_episode_picker_controller';
import c33 from './preview_controller';
import c34 from './preview_target_controller';
import c35 from './promotion_order_controller';
import c36 from './range_selector_controller';
import c37 from './reorderable_list_controller';
import c38 from './scroll_to_controller';
import c39 from './search_filter_controller';
import c40 from './search_toggle_controller';
import c41 from './share_link_controller';
import c42 from './status_page_controller';
import c43 from './stripe_confirm_controller';
import c44 from './stripe_payment_controller';
import c45 from './switch_subdomain_controller';
import c46 from './tiptap_controller';
import c47 from './tom_select_controller';
import c48 from './trix_default_message_controller';
import c49 from './trix_no_attachments_controller';
import c50 from './trix_restricted_toolbar_controller';
import c51 from './trix_upload_controller';
import c52 from './visibility_toggle_controller';
import c53 from './welcome_message_controller';
export const definitions = [
	{identifier: 'address-geocode-prefill', controllerConstructor: c0},
	{identifier: 'ama-publish', controllerConstructor: c1},
	{identifier: 'amount-toggle', controllerConstructor: c2},
	{identifier: 'auto-save', controllerConstructor: c3},
	{identifier: 'autolink', controllerConstructor: c4},
	{identifier: 'beacon-link', controllerConstructor: c5},
	{identifier: 'bridge--beacon-link', controllerConstructor: c6},
	{identifier: 'bridge--intercom', controllerConstructor: c7},
	{identifier: 'bridge--menu', controllerConstructor: c8},
	{identifier: 'bridge--navigation', controllerConstructor: c9},
	{identifier: 'click-tracker', controllerConstructor: c10},
	{identifier: 'confirmation', controllerConstructor: c11},
	{identifier: 'copy-to-clipboard', controllerConstructor: c12},
	{identifier: 'custom-domain-validation', controllerConstructor: c13},
	{identifier: 'email-validation', controllerConstructor: c14},
	{identifier: 'expandable-content', controllerConstructor: c15},
	{identifier: 'extra-support', controllerConstructor: c16},
	{identifier: 'feed-item-switcher', controllerConstructor: c17},
	{identifier: 'form', controllerConstructor: c18},
	{identifier: 'highcharts', controllerConstructor: c19},
	{identifier: 'image-preview', controllerConstructor: c20},
	{identifier: 'live-activity-feed', controllerConstructor: c21},
	{identifier: 'live-poll-dashboard', controllerConstructor: c22},
	{identifier: 'live-poll-options', controllerConstructor: c23},
	{identifier: 'login-code', controllerConstructor: c24},
	{identifier: 'login', controllerConstructor: c25},
	{identifier: 'new-tab-link', controllerConstructor: c26},
	{identifier: 'notification-preferences', controllerConstructor: c27},
	{identifier: 'password-validator', controllerConstructor: c28},
	{identifier: 'plan-toggle', controllerConstructor: c29},
	{identifier: 'plan-unwrap', controllerConstructor: c30},
	{identifier: 'play-controls', controllerConstructor: c31},
	{identifier: 'post-episode-picker', controllerConstructor: c32},
	{identifier: 'preview', controllerConstructor: c33},
	{identifier: 'preview-target', controllerConstructor: c34},
	{identifier: 'promotion-order', controllerConstructor: c35},
	{identifier: 'range-selector', controllerConstructor: c36},
	{identifier: 'reorderable-list', controllerConstructor: c37},
	{identifier: 'scroll-to', controllerConstructor: c38},
	{identifier: 'search-filter', controllerConstructor: c39},
	{identifier: 'search-toggle', controllerConstructor: c40},
	{identifier: 'share-link', controllerConstructor: c41},
	{identifier: 'status-page', controllerConstructor: c42},
	{identifier: 'stripe-confirm', controllerConstructor: c43},
	{identifier: 'stripe-payment', controllerConstructor: c44},
	{identifier: 'switch-subdomain', controllerConstructor: c45},
	{identifier: 'tiptap', controllerConstructor: c46},
	{identifier: 'tom-select', controllerConstructor: c47},
	{identifier: 'trix-default-message', controllerConstructor: c48},
	{identifier: 'trix-no-attachments', controllerConstructor: c49},
	{identifier: 'trix-restricted-toolbar', controllerConstructor: c50},
	{identifier: 'trix-upload', controllerConstructor: c51},
	{identifier: 'visibility-toggle', controllerConstructor: c52},
	{identifier: 'welcome-message', controllerConstructor: c53},
];
